/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
// Business names often have unicode characters that we need to maintain.
// The solution here is a lightweight solution suggested by Mozilla
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding

import _ from 'lodash';

import { fromByteArray, toByteArray } from 'base64-js';

import { TockCookieName } from '@tock/shared/constants/browser-storage/TockCookies';
import { appendCookieSuffixes, getCookie, setCookie } from '@tock/shared/utils/cookieUtils';
import env from '@tock/shared/utils/env';

const encoder = new TextEncoder();
const decoder = new TextDecoder();

/* business cookie encoding / decoding functions */
function encodeBusinessCookie(cookieValue: object) {
  return fromByteArray(encoder.encode(JSON.stringify(cookieValue)));
}

function decodeBusinessCookie(encodedCookie: string) {
  return JSON.parse(decoder.decode(toByteArray(encodedCookie)));
}

/* Specific cookie functions */
export function getActiveBusinessCookie(domain: string) {
  let activeBusinessCookie = getCookie(getActiveBusinessCookieName(domain));
  if (!activeBusinessCookie) {
    return null;
  }

  try {
    activeBusinessCookie = decodeBusinessCookie(activeBusinessCookie);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return null;
  }
  return activeBusinessCookie;
}

const cookieEnvOverride = process?.env?.cookieEnvOverride;

export function setActiveBusinessCookie(domain: string, cookieValue: object, expiration: number) {
  if (_.isEmpty(cookieValue)) {
    setCookie(TockCookieName.ACTIVE_BUSINESS, '', {
      expirationFromNow: expiration,
      suffixOptions: {
        envSuffix: cookieEnvOverride ?? env.get(domain),
      },
    });
    return;
  }
  const valueToSet = encodeBusinessCookie(cookieValue);
  setCookie(TockCookieName.ACTIVE_BUSINESS, valueToSet, {
    expirationFromNow: expiration,
    suffixOptions: {
      envSuffix: cookieEnvOverride ?? env.get(domain),
    },
  });
}

export function getActiveBusinessCookieName(domain: string) {
  const environmentName = cookieEnvOverride ?? env.get(domain);
  return appendCookieSuffixes(TockCookieName.ACTIVE_BUSINESS, {
    envSuffix: environmentName,
  });
}
